import { makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    width: "100%",
    "& > :first-child": {
      flexGrow: 1
    },
    "& > :last-child > *": {
      marginLeft: theme.spacing(1)
    }
  }
}));
const HeadBar = ({ children, toolbar }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>{children}</div>
      {toolbar}
    </div>
  );
};

export default HeadBar;
